import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { toArray } from "./toArray.js";
export const single = (source, predicate) => {
    if (predicate) {
        return single2(source, predicate);
    }
    else {
        return single1(source);
    }
};
const single1 = async (source) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const results = await dataFunc.generator();
            if (results.length > 1) {
                throw new InvalidOperationException(ErrorString.MoreThanOneElement);
            }
            else if (results.length === 0) {
                throw new InvalidOperationException(ErrorString.NoElements);
            }
            return results[0];
        }
        case 1: {
            const results = dataFunc.generator();
            if (results.length > 1) {
                throw new InvalidOperationException(ErrorString.MoreThanOneElement);
            }
            else if (results.length === 0) {
                throw new InvalidOperationException(ErrorString.NoElements);
            }
            return results[0];
        }
        case 2: {
            const results = await dataFunc.generator();
            if (results.length > 1) {
                throw new InvalidOperationException(ErrorString.MoreThanOneElement);
            }
            else if (results.length === 0) {
                throw new InvalidOperationException(ErrorString.NoElements);
            }
            return await results[0];
        }
    }
};
const single2 = async (source, predicate) => {
    const results = await toArray(source);
    let hasValue = false;
    let singleValue = null;
    for (const value of results) {
        if (predicate(value)) {
            if (hasValue === true) {
                throw new InvalidOperationException(ErrorString.MoreThanOneMatchingElement);
            }
            else {
                hasValue = true;
                singleValue = value;
            }
        }
    }
    if (hasValue === false) {
        throw new InvalidOperationException(ErrorString.NoMatch);
    }
    return singleValue;
};
